import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/** Une clases de Tailwind resolviendo conflictos (patrón `cn` de shadcn). */
export function cn(...entradas: ClassValue[]): string {
  return twMerge(clsx(entradas));
}
